
export const ENDPOINTS = {
  chat: {
    stream: `/api/chat/stream`,
    raw: `/api/chat`,
  },
} as const;